<template>
  <v-app>
    <div class="background secondary"></div>
    <v-row class="row-wrapper">
      <v-col
        class="col-wrapper"
        cols="12"
        md="12"
        offset-md="0"
        lg="6"
        offset-lg="3"
        xl="4"
        offset-xl="4"
      >
        <v-app-bar class="header" color="primary" dark app flat>
          <router-link to="/">
            <div class="d-flex align-center">
              <v-img
                alt="FairFinder Logo"
                class="shrink"
                contain
                src="@/assets/img/logo.png"
                transition="scale-transition"
                width="110"
              />
            </div>
          </router-link>

          <v-spacer></v-spacer>

          <div class="shrink">
            <v-btn @click="searchInfo = true" icon>
              <v-icon>mdi-magnify</v-icon>
            </v-btn>

            <v-btn @click="$navigateTo('Favorites')" icon>
              <v-icon>mdi-heart-outline</v-icon>
            </v-btn>
          </div>
        </v-app-bar>

        <v-content class="content">
          <router-view />
        </v-content>

        <v-snackbar v-model="searchInfo" @click="searchInfo = false" bottom
          >Die Suchfunktion ist bald verfügbar!</v-snackbar
        >

        <v-footer class="mt-4" color="primary" flat padless>
          <v-row justify="center" no-gutters>
            <v-btn to="/legal-notice" color="white" class="my-2" text
              >Impressum</v-btn
            >
            <v-btn to="/privacy" color="white" class="my-2" text
              >Datenschutz</v-btn
            >

            <v-col class="pb-4 text-center white--text" cols="12">
              {{ new Date().getFullYear() }} —
              <strong>
                <a
                  style="color: white"
                  target="_blank"
                  href="https://heimathafen-nf.de"
                  >Heimathafen e.K.</a
                >
              </strong>
            </v-col>
          </v-row>
        </v-footer>
      </v-col>
    </v-row>
  </v-app>
</template>

<style lang="scss" scoped>
.background {
  position: fixed;
  height: 100vh;
  width: 100vw;
  z-index: 0;
}

.row-wrapper {
  margin: 0;
  .col-wrapper {
    padding: 0;
    background-color: white;
    z-index: 1;

    .header {
      position: relative !important;
    }

    .content {
      padding-top: 0 !important;
      min-height: 90vh;
    }
  }
}
</style>

<script>
export default {
  name: "App",

  data: () => ({
    searchInfo: false
  })
};
</script>
